const ComplementoInteresesHipotecariosRules = {
  CreditoDeInstFinanc: [
    'required',
    'string',
    'in:SI,NO',
  ],
  SaldoInsoluto: [
    'required',
    'decimal:6',
  ],
  PropDeducDelCredit: [
    'decimal:6',
  ],
  MontTotIntNominalesDev: [
    'decimal:6',
  ],
  MontTotIntNominalesDevYPag: [
    'decimal:6',
  ],
  MontTotIntRealPagDeduc: [
    'decimal:6',
  ],
  NumContrato: [
    'string',
    'min:1',
    'max:300',
  ],
};

export default ComplementoInteresesHipotecariosRules;
